<template>
  <div class="workspaces">
    <div
      v-for="(workspace, index) in workspaces"
      :key="workspace.id"
      :class="`workspaces__item ${
        index === currWorkspaceIndex ? 'active' : ''
      }`"
      :title="workspace.clinic.name"
      @click="setCurrentWorkspace(index)"
    >
      <div class="workspaces__avatar">
        <img
          v-if="workspace.clinic.imageUrl"
          :src="workspace.clinic.imageUrl"
        />
        <span v-else>
          {{ workspace.clinic.initials }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Workspaces',

  computed: {
    ...mapState('dashboard', {
      workspaces: ({ workspaces }) => workspaces,
      currWorkspaceIndex: ({ currWorkspaceIndex }) => currWorkspaceIndex,
    }),
  },

  methods: {
    ...mapActions('dashboard', ['setCurrentWorkspace']),
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
